import { Tooltip as HeroTooltip } from "@heroui/react";

export const Tooltip = HeroTooltip;
